import React from "react";
import { Card } from "../../Shared/Card";
import { ListTable } from "./ListTable";
import { Separator } from "../../ui/separator";
import { DateRangePicker } from "../../ui/datepicker";

export const ListDashboard: React.FC = () => {
	const [selectedRange, setSelectedRange] = React.useState<{
		from: Temporal.PlainDate | undefined;
		to: Temporal.PlainDate | undefined;
	}>({
		from: undefined,
		to: undefined,
	});

	return (
		<Card>
			<h1 className="text-xl font-bold">Listado de Imputaciones</h1>
			<Separator />
			<DateRangePicker value={selectedRange} onChange={setSelectedRange} />
			<ListTable
				filter={{
					range: selectedRange,
				}}
			/>
		</Card>
	);
};
